var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { configureHandler } from 'mocks/helpers';
import courseSection622453Student5167001 from './_data/622453-5167001';
import courseSection523822Student5846998 from './_data/523822-5846998';
import courseSection516809Student6037438 from './_data/516809-6037438';
import courseSection622453Student6952847 from './_data/622453-6952847';
import courseSection516809Student3047711 from './_data/516809-3047711';
import courseSection516809Student6952847 from './_data/516809-6952847';
import courseSection622453Student6037438 from './_data/622453-6037438';
import courseSection516809Student5167001 from './_data/516809-5167001';
import courseSection516809Student5846998 from './_data/516809-5846998';
import courseSection622453Student3047711 from './_data/622453-3047711';
import courseSection523822Student6037438 from './_data/523822-6037438';
import courseSection523822Student6308003 from './_data/523822-6308003';
import courseSection523822Student6952847 from './_data/523822-6952847';
import courseSection523822Student5167001 from './_data/523822-5167001';
import courseSection622453Student5846998 from './_data/622453-5846998';
var data = {
    // Course (568749): GSM Demo - Sherpath Vantage for Potter Fundamentals of Nursing
    '568749-5167001': courseSection622453Student5167001,
    '568749-5846998': courseSection622453Student5846998,
    '568749-3047711': courseSection622453Student3047711,
    '568749-6037438': courseSection622453Student6037438,
    '568749-6952847': courseSection622453Student6952847,
    // Course (554121):  (DEMO) Spring 2024 - Sherpath Vantage for Potter Fundamentals of Nursing
    '554121-6037438': courseSection523822Student6037438,
    '554121-6308003': courseSection523822Student6308003,
    '554121-6952847': courseSection523822Student6952847,
    '554121-5167001': courseSection523822Student5167001,
    '554121-5846998': courseSection523822Student5846998,
    // Course (471204): Sherpath Vantage for Harding Lewis's Medical-Surgical Nursing, 12th Edition
    '471204-6037438': courseSection516809Student6037438,
    '471204-3047711': courseSection516809Student3047711,
    '471204-6952847': courseSection516809Student6952847,
    '471204-5167001': courseSection516809Student5167001,
    '471204-5846998': courseSection516809Student5846998
};
export default configureHandler(function (req, res, ctx) { return __awaiter(void 0, void 0, void 0, function () {
    var queryParams, courseSectionId, studentId, key;
    return __generator(this, function (_a) {
        queryParams = req.url.searchParams;
        courseSectionId = queryParams.get('courseSectionId');
        studentId = queryParams.get('userId');
        key = "".concat(courseSectionId, "-").concat(studentId);
        if (!data[key]) {
            return [2 /*return*/, req.passthrough()];
        }
        return [2 /*return*/, res(ctx.status(200), ctx.json(data[key]))];
    });
}); });
